<div class="left-col" appClickAnywhere (clickNature)="getClickNature($event)">
  <div class="overlay"></div>
</div>
<div class="right-col" appClickAnywhere (clickNature)="getClickNature($event)">
    <app-progress-bar [hightlightedSteps]="hightlightedSteps"></app-progress-bar>
    <app-go-back-button [routerLink]="['/subscribe-step-one']"></app-go-back-button>
    <app-header></app-header>
    
    @if(loading$ | async){
        <app-loader></app-loader>
    }

    <form
        [formGroup]="subSecondFormGroup"   
        (ngSubmit)="onSubmit()"
        id="subSecondForm"
    >
      <app-city-input formGroupName="locationCtrl" [user]="user" (emitCity)="getCitySelected($event)"></app-city-input>
    </form>

    <div class="submit-btn-container">
      <button 
          routerLinkActive="router-link-active"
          class="submit"
          [disabled]="!citySet.id"
          form="subSecondForm"
          i18n="Text for the button to go the next step in the subscription form@@NEXT"
      >
          Next
          <span class="material-symbols-rounded arrow-right">
              arrow_right_alt
          </span>
      </button>
  </div>
</div>
